import { generateId, type Overview, type OverviewBlock } from '@gm-binder/shared';

/** Legacy fixed overview keys → a titled block (used to migrate old adventures, non-destructively). */
const LEGACY_BLOCKS: { key: string; title: string; icon: string }[] = [
  { key: 'prologue', title: 'Prologo', icon: '📜' },
  { key: 'hookExtra', title: 'Aggancio', icon: '🪝' },
  { key: 'victory', title: 'Condizioni di vittoria', icon: '🏆' },
  { key: 'deathRule', title: 'Regola della morte', icon: '💀' },
  { key: 'twistFinale', title: 'Colpo di scena finale', icon: '🌀' },
  { key: 'credits', title: 'Crediti', icon: '🎬' },
];

/**
 * The overview's titled sections. When `overview.sections` exists it wins; otherwise we derive
 * blocks from the legacy fixed keys so old adventures keep rendering until the GM edits them.
 */
export function overviewSections(overview: Overview | undefined): OverviewBlock[] {
  if (!overview) return [];
  if (Array.isArray(overview.sections)) return overview.sections;
  const legacy = overview as unknown as Record<string, unknown>;
  return LEGACY_BLOCKS.filter(
    ({ key }) => typeof legacy[key] === 'string' && (legacy[key] as string).trim(),
  ).map(({ key, title, icon }) => ({
    id: key,
    title,
    body: String(legacy[key]),
    icon,
  }));
}

/** A fresh, empty overview block with a stable id. */
export function newOverviewBlock(): OverviewBlock {
  return { id: generateId('ov'), title: 'Nuova sezione', body: '', icon: '📖' };
}
